import BuildingHistoryController from './BuildingHistoryController'

export { default } from './BuildingHistory'

export const BuildingHistoryMapConfig = {
  Controller: BuildingHistoryController,
}
